import { Link } from 'react-router-dom';
import type { NavLink } from './SiteHeader';
import logoNavy from '@/assets/logos/new-site/logo.svg';
import logoWhite from '@/assets/logos/new-site/logo-white.svg';

interface SiteFooterProps {
  /** 'light' = off-white footer (product pages); 'dark' = navy footer (Hub). */
  variant?: 'light' | 'dark';
  navLinks: NavLink[];
}

function FooterLink({ link, color }: { link: NavLink; color: string }) {
  const style = { fontSize: 14, fontWeight: 500, color };
  if (link.href === '/') {
    return (
      <Link to="/" style={style}>
        {link.label}
      </Link>
    );
  }
  return (
    <a href={link.href} style={style}>
      {link.label}
    </a>
  );
}

/** Site footer shared by the Hub (dark) and the three product pages (light). */
export default function SiteFooter({ variant = 'light', navLinks }: SiteFooterProps) {
  const container = {
    maxWidth: 1180,
    margin: '0 auto',
    padding: '40px 28px',
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: 24,
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  if (variant === 'dark') {
    return (
      <footer style={{ background: '#24276C' }}>
        <div style={container}>
          <div>
            <img
              src={logoWhite}
              alt="F&B Insights"
              style={{ height: 26, width: 'auto', display: 'block', marginBottom: 8 }}
            />
            <div style={{ fontSize: 13, color: '#9AA0C8' }}>© 2026 F&amp;B Insights</div>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 26, alignItems: 'center' }}>
            {navLinks.map((link) => (
              <FooterLink key={link.href} link={link} color="#C7CBE4" />
            ))}
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer style={{ borderTop: '1px solid #ECEBE6', background: '#F6F6F4' }}>
      <div style={container}>
        <Link to="/">
          <img
            src={logoNavy}
            alt="F&B Insights"
            style={{ height: 26, width: 'auto', display: 'block' }}
          />
        </Link>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 26, alignItems: 'center' }}>
          {navLinks.map((link) => (
            <FooterLink key={link.href} link={link} color="#54545E" />
          ))}
        </div>
        <div style={{ fontSize: 13, color: '#8A8A93' }}>© 2026 F&amp;B Insights</div>
      </div>
    </footer>
  );
}
